module.exports = __webpack_public_path__ + "img/glogo207.14cc0ab8.png";